import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex flex-row justify-between w-full" }
const _hoisted_3 = { class: "flex flex-row w-4/6 truncate justify-start" }
const _hoisted_4 = { class: "flex flex-col ml-2 w-5/6" }
const _hoisted_5 = { class: "leading-none text-base pt-1 font-semibold truncate" }
const _hoisted_6 = { class: "text-gray-500 text-sm truncate font-medium" }
const _hoisted_7 = { class: "flex w-2/6 justify-end items-start" }
const _hoisted_8 = { class: "truncate text-xs px-2 text-gray-400 font-light p-2" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Job applications ")
const _hoisted_10 = { class: "bg-gray-100 px-2 py-1 rounded-full" }
const _hoisted_11 = { class: "flex flex-col justify-center items-center mt-2 text-sm" }
const _hoisted_12 = { class: "flex w-4/5 flex-col" }
const _hoisted_13 = { class: "text-gray-400 leading-none" }
const _hoisted_14 = { class: "leading-none mt-1 truncate text-gray-400" }
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = {
  key: 0,
  class: "flex flex-row truncate text-xs space-x-1"
}
const _hoisted_17 = {
  key: 0,
  class: "text-primary px-2 py-1 bg-primary-light rounded-lg"
}
const _hoisted_18 = {
  key: 1,
  class: "text-primary-dark"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "" }, "No skills added", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "p-3",
      key: `card-candidate-${item.first_name}-${item.last_name}-${index}`
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["sm:w-full flex flex-col p-4 bg-white rounded-2xl border-2 border-transparent shadow cursor-pointer h-40", { 'border-2 border-primary': !item.has_job }]),
        onClick: ($event: any) => (_ctx.viewCandidate(item.id))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Avatar, {
              name: `${item.first_name} ${item.last_name}`,
              size: "xs"
            }, null, 8, ["name"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(`${item.first_name} ${item.last_name}`), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.position ? item.position : "No position"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(item.job_applications ? item.job_applications : "-"), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(item && item.salary_expectation.annual
                ? `$${_ctx.numberWithCommas(
                    parseInt(
                      item.show_monthly_salaries
                        ? item.salary_expectation.to_show
                        : item.salary_expectation.annual,
                      10
                    )
                  )} ${item.salary_currency}`
                : "No salary"), 1),
            _createElementVNode("span", _hoisted_14, _toDisplayString(item.candidate_location
                ? item.candidate_location.location.street_address
                : "No address"), 1),
            _createElementVNode("div", _hoisted_15, [
              (item && item.skills && item.skills.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item && item.skills && item.skills.length > 0
                  ? item.skills.slice(0, 4)
                  : [], (chip) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-row",
                        key: chip
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-primary px-2 py-1 bg-primary-light rounded-lg truncate", [
                    chip.length <= 12 || item.skills.length <= 3 ? '' : 'w-20',
                  ]])
                        }, _toDisplayString(chip), 3)
                      ]))
                    }), 128)),
                    (item.skills.length > 4)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, " + " + _toDisplayString(item.skills.length - 4) + " skills", 1))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
            ])
          ])
        ])
      ], 10, _hoisted_1)
    ]))
  }), 128))
}